'use strict';
/**
 * Hides components when an old version of IE is detected
 */

(function () {

  angular.module('msUtility').directive('msHideOldBrowser', msHideOldBrowser);

  msHideOldBrowser.$inject = [];

  function msHideOldBrowser() {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element) {
      if (_.includes(navigator.userAgent, 'MSIE') || _.includes(navigator.appVersion, 'Trident/')) {
        element.remove();
      }
    }
  }
})();